import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrServiceSchedulingKind.ts
var t = () => e("serviceSchedulingKind");
//#endregion
export { t as useTrServiceSchedulingKind };
